import * as agentActions from './agentActions';
import * as electionActions from './electionActions';
import * as globalActions from './global';
import * as kycActions from './kycActions';
import * as locationActions from './locationActions';
import * as otherActions from './otherActions';
import * as resultActions from './resultsActions';

export const actions = {
	...globalActions,
	...resultActions,
	...otherActions,
	...electionActions,
	...agentActions,
	...locationActions,
	...kycActions,
};
